import React, { useMemo } from 'react';

import useCampaign from '../../../hooks/use_campaign';
import useGroup from '../../../hooks/use_group';
import useProduct from '../../../hooks/use_product';
import useSiteMetadata from '../../../hooks/use_site_metadata';
import useTranslation from '../../../hooks/use_translation';
import liveBio from '../../../images/header/live/live-bio.jpg';
import liveHealthCheck from '../../../images/header/live/live-offer-health-check.jpg';
import ProductGroupIcon from '../../test/product-group-icon';
import GroupLink from '../group_link';
import Link from '../link';
import AllTestIcon from '../svgs/icons/all-test-icon';
import DealIcon from '../svgs/icons/deal-icon';
import HealthCheckIcon from '../svgs/icons/health-check-icon';
import MRIIcon from '../svgs/icons/mri-icon';
import SampleGroupIcon from '../svgs/icons/sample-group-icon';

const buttons = [
	{ icon: <AllTestIcon className="lg" />, label: 't1', to: '/tester' },
	{
		icon: <DealIcon className="lg" />,
		label: 't2',
		to: '/tester/?discount=true',
	},
	{
		icon: <HealthCheckIcon className="lg" />,
		label: 't3',
		to: '/tester/?product_type=checkup',
	},
	{
		icon: <SampleGroupIcon className="lg" />,
		label: 't7',
		to: '/tester/?product_type=package',
	},
	{
		label: 't9',
		to: '/allergitester',
	},
	{
		icon: <MRIIcon className="lead" />,
		label: 't10',
		to: '/halsoundersokningar/mr-rontgen/',
	},
];

const CategoryDropdown = () => {
	const { image, isActive } = useCampaign();
	const siteMetadata = useSiteMetadata();
	const { t } = useTranslation('component_header_dropdown');

	const { items: groups } = useGroup({
		exclude_groups: [...siteMetadata.config.business_tests_groups],
	});
	const { items: products } = useProduct({ has_markers: true });

	const closeOffcanvas = () => {
		const offcanvasElement = document.querySelector('.offcanvas.show');

		const backdrop = document.querySelector('.offcanvas-backdrop');

		if (offcanvasElement) {
			offcanvasElement.classList.remove('show');

			setTimeout(() => {
				if (backdrop) {
					backdrop.remove();
				}
				document.body.classList.remove('offcanvas-open');
			}, 300);
		}
	};

	const liveItems = useMemo(() => {
		const list = [];

		if (isActive && image) {
			list.push({
				image: image,
				label: 't11',
				to: '/kampanjer',
			});
		}

		list.push(
			{
				image: liveHealthCheck,
				label: 't8',
				to: '/tester/?product_type=checkup&discount=true',
			},
			{
				image: liveBio,
				label: 't4',
				to: '/tester/?product_settings=include_biological_age',
			},
		);

		return list;
	}, [isActive, image]);

	return (
		<>
			<div className="dropdown-menu dropdown-menu-fullw py-4" role="menu">
				<div className="container px-0 px-lg-2">
					<div className="row">
						<div className="col-lg-3">
							<h3 className="fw-700 lg mb-3">{t('t5')}</h3>
							<ul className="list-unstyled list-group list-group-flush dropdown-menu-featured">
								{buttons.map((button, index) => (
									<li key={index}>
										<Link
											className="btn btn-light rounded-pill fw-600 text-dark mb-3 w-100"
											onClick={closeOffcanvas}
											to={button.to}
										>
											{button.icon} {t(button.label)}
										</Link>
									</li>
								))}
							</ul>
							<h3 className="fw-700 lg mb-3 mt-4">{t('t6')}</h3>
							<ul className="list-unstyled dropdown-menu-live mb-4 row">
								{liveItems.map((live_items, index) => (
									<li
										className="mb-2 col-6 dropdown-menu-live-item"
										key={index}
									>
										<Link
											className="mb-3 w-100 dropdown-menu-live-item-link"
											onClick={closeOffcanvas}
											to={live_items.to}
										>
											<div className="bg-dark-filter" />
											<img
												alt="Live 1"
												className="dropdown-menu-live-item-img"
												src={live_items.image}
											/>
											<span className="dropdown-menu-live-item-text">
												{t(live_items.label)}
											</span>
										</Link>
									</li>
								))}
							</ul>
						</div>
						<div className="col-lg-9">
							<ul className="list-unstyled list-group list-group-flush dropdown-menu-grid">
								{groups.map((group, index1) => {
									const products_filtered = products.filter((product) => {
										return product.groups.includes(group.group_id);
									});
									if (!products_filtered?.length) {
										return null;
									}

									return (
										<li
											className="list-group-item  p-0  dropdown-item d-flex align-items-center "
											key={index1}
										>
											<GroupLink
												className="d-flex justify-content-between align-items-center px-3 py-2 w-100"
												groups={[group.group_id]}
												page="tester"
											>
												<div className="d-flex align-items-center">
													<ProductGroupIcon
														alt={group.group_variant.title}
														groups={[group.group_id]}
														type="list"
													/>
													{group.group_variant.title}{' '}
												</div>
												<span className="badge bg-light text-dark rounded-pill px-3">{`${products_filtered.length}`}</span>
											</GroupLink>
										</li>
									);
								})}
							</ul>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default CategoryDropdown;
